export enum FlightStateEnum {
  IDLE = 'IDLE',
  FLYING = 'FLYING',
  SCANNING = 'SCANNING',
  HOVERING = 'HOVERING',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
}
